<template>
  <div class="room-card__inf">
    <div class="icon-font">
      <svg-icon :type="icon" />
    </div>
    <div class="btn-txt">
      {{ !!param ? param + ' ' + text : text }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: String,
    text: String,
    param: String || Number
  }
}
</script>

<style lang="scss">
.icon-font {
  margin-right: 11px;
  font-size: 21px;
}
</style>
